import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { useProfile } from "../../../context/ProfileContext";
import { LayoutBaseDePagina } from "../../../shared/layouts"; // Layout do projeto
import { SetupChargeTab } from "./tabs/SetupChargeTab";
import { SetupFeeTab } from "./tabs/SetupFeeTab";
import { TabComission } from "./tabs/TabComission";
import { TabLivve } from "./tabs/TabLivve";

export const FinancialPassPresentation = () => {
	const { isSuperAdmin } = useProfile();
	// Ação granular Livve — pedido formalizado pro backend, ver GAPS_LIVVE_V2_PARA_BACKEND.md.
	const canViewLivve = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.LivveView);
	const [selectedTab, setSelectedTab] = useState(0); // Estado para gerenciar a tab selecionada

	// Função para controlar a mudança de tab
	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setSelectedTab(newValue);
	};

	return (
		<LayoutBaseDePagina titulo="Repasses, Comissões e Bonificações" subtitulo="Controle de Repasses, Comissões , Bonificações" barraDeFerramentas={<></>}>
			<Tabs
				value={selectedTab}
				onChange={handleTabChange}
				aria-label="Repasses, Comissões e Bonificações"
				sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper", mx: 1, borderRadius: 1, bordercolor: "divider" }}
			>
				<Tab label="Bonificações" />
				<Tab label="Taxa Setup" />
				<Tab label="Setup Avulsa" />
				{canViewLivve && <Tab label="Livve" />}
			</Tabs>

			<Box sx={{ pt: 1 }}>
				{/* Tab de Cartão de Crédito */}
				{selectedTab === 0 && <TabComission />}

				{/* Tab de Faturamento */}
				{selectedTab === 1 && <SetupFeeTab />}

				{/* Tab Setup Avulsa */}
				{selectedTab === 2 && <SetupChargeTab />}

				{/* Tab Livve */}
				{selectedTab === 3 && canViewLivve && <TabLivve />}
			</Box>
		</LayoutBaseDePagina>
	);
};
